import React, { useState } from "react";
import AutoComplete from "@mui/material/Autocomplete";
import { useEffect } from "react";
import { MdArrowDropDown } from "react-icons/md";
import TextInput from "../TextInput/TextInput";
import { createFilterOptions, Popper, styled } from "@mui/material";
import { useSelector } from "react-redux";
import SpinnerLoader from "../../../../../components/CardSkeletonLoader/SpinnerLoader/SpinnerLoader";

const Select = ({
  options = [{ code: "", display_name: "" }],
  handleChange = () => {},
  selectedValue,
  label,
  error,
  readOnly,
  dropdownHeight,
  annualIncome,
  pincodeFetch,
  ...props
}) => {
  const [value, setValue] = useState(null);
  const { isAddressFetching } = useSelector(state => state.eligibility);
  const [inputValue, setInputValue] = useState("");
  const onChange = (e, value) => {
    setValue(value);
    handleChange(value.code);
  };
  useEffect(() => {
    if (selectedValue) {
      const x = options.find(item => item.code === selectedValue);
      setValue(x || null);
      setInputValue(x?.display_name || "");
    } else {
      setValue(null);
      setInputValue("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);
  const onInputChange = (e, newValue) => {
    setInputValue(newValue);
  };
  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: option =>
      annualIncome ? option.code.toString() : option.display_name,
  });

  return (
    <>
      {" "}
      {readOnly ? (
        <TextInput
          value={inputValue}
          label={label}
          inputProps={{ readOnly: true }}
        />
      ) : (
        <StyledAutoComplete
          filterOptions={filterOptions || ""}
          options={options}
          disablePortal
          disableClearable
          blurOnSelect
          onChange={onChange}
          onInputChange={onInputChange}
          getOptionLabel={item => item.display_name || ""}
          value={value}
          clearOnBlur
          popupIcon={
            pincodeFetch && isAddressFetching ? (
              <SpinnerLoader />
            ) : (
              <MdArrowDropDown />
            )
          }
          inputValue={inputValue || ""}
          PopperComponent={({ style, ...props }) => (
            <Popper {...props} style={{ ...style, height: 0 }} />
          )}
          ListboxProps={{
            style: {
              maxHeight: dropdownHeight ? dropdownHeight : "50vh",
            },
          }}
          isOptionEqualToValue={(item, value) => item.code === value.code}
          renderInput={params => (
            <TextInput
              {...params}
              label={label}
              error={error}
              inputProps={{
                ...params.inputProps,
                autoComplete: props?.autoComplete,
                readOnly: props?.noSearch,
              }}
            />
          )}
        />
      )}
    </>
  );
};
const StyledAutoComplete = styled(AutoComplete)({
  "& .MuiOutlinedInput-root": {
    padding: "0px 0 0 14px !important",
    color: "#000 !important",
  },
  "& .MuiOutlinedInput-input": {
    padding: "0 !important",
  },
});
export default Select;
